import homeReducer from "./pages/home/homeReducer";
import myChartsReducer from "./pages/myCharts/myChartsReducer";


export default {
    homePage: homeReducer,
    myChart: myChartsReducer,
};